import { useCallback } from 'react';
import { Routes, GameParams, GAME_WITH_BOT_KEY, Storage } from '@whitesharx/starfall-frontend-core';
import { useRouter } from 'next/router';

const useGoGame = () => {
  const router = useRouter();

  return useCallback((params: GameParams) => {
    let query: GameParams;
    const { mode, withBot, botLevel, playerColor, gameLevel, clubName, onboarding } = params;

    if (params.withBot) {
      Storage.removeItem(GAME_WITH_BOT_KEY);
      query = {
        mode,
        playerColor,
        withBot,
        botLevel,
        ...(onboarding && { onboarding }),
        ...(gameLevel && { gameLevel }),
      };
    } else {
      query = { mode, clubName, ...(onboarding && { onboarding }), ...(gameLevel && { gameLevel }) };
    }

    router.push({
      pathname: Routes.game,
      query,
    });
  }, []);
};

export default useGoGame;
